"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImageModal = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _ProductImage = require("../../atoms/ProductImage");

var _ImageDataTable = require("../ImageDataTable");

var _ImageSelector = require("../../molecules/ImageSelector");

var _react = require("react");

var _ValidationPanel = require("../../atoms/ValidationPanel");

var _GeneralButton = require("../../atoms/GeneralButton");

var _jsxRuntime = require("react/jsx-runtime");

var ProductImageModal = function ProductImageModal(_ref) {
  var _images$values$active, _images$values$active2, _images$values$active3;

  var _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      headerInfo = _ref.headerInfo,
      validation = _ref.validation,
      setShowModal = _ref.setShowModal,
      sendToFacilitator = _ref.sendToFacilitator,
      _ref$approveRejectBut = _ref.approveRejectButtons,
      approveRejectButtons = _ref$approveRejectBut === void 0 ? false : _ref$approveRejectBut;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeImage = _useState2[0],
      setActiveImage = _useState2[1];

  var _useState3 = (0, _react.useState)(validation ? validation : "null-button"),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      buttonType = _useState4[0],
      setButtonType = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showValidationPanel = _useState6[0],
      setShowValidationPanel = _useState6[1];

  var closeValidationPanel = function closeValidationPanel(e) {
    if (!e.target.closest("#validation-panel") || e.target.closest(".validation-option") && showValidationPanel) {
      document.removeEventListener("click", closeValidationPanel, false);
      setShowValidationPanel(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (showValidationPanel) {
      document.addEventListener("click", closeValidationPanel, false);
    }
  }, [showValidationPanel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "modal-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal-image-container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductImage.ProductImage, {
          img: "https://" + process.env.REACT_APP_IMAGES_BUCKET + ".s3.amazonaws.com/" + (images === null || images === void 0 ? void 0 : (_images$values$active = images.values[activeImage]) === null || _images$values$active === void 0 ? void 0 : _images$values$active.srcDB),
          altText: images === null || images === void 0 ? void 0 : (_images$values$active2 = images.values[activeImage]) === null || _images$values$active2 === void 0 ? void 0 : _images$values$active2.name,
          imageType: "expanded-modal-image"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "modal-data-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "validation-and-table-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "validation-panel",
            children: [approveRejectButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
              buttonType: "circular-button ".concat(buttonType),
              onClick: function onClick() {
                return setShowValidationPanel(true);
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
              buttonType: "close-button",
              onClick: function onClick() {
                setShowModal(false);
              }
            }), showValidationPanel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ValidationPanel.ValidationPanel, {
              id: "validation-panel",
              setOptionClicked: setButtonType,
              setShowValidationPanel: setShowValidationPanel,
              approve: function approve() {
                return sendToFacilitator && sendToFacilitator("A");
              },
              reject: function reject() {
                return sendToFacilitator && sendToFacilitator("R");
              }
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageDataTable.ImageDataTable, {
            imageData: images === null || images === void 0 ? void 0 : (_images$values$active3 = images.values[activeImage]) === null || _images$values$active3 === void 0 ? void 0 : _images$values$active3.data,
            headerInfo: headerInfo,
            activeImage: images === null || images === void 0 ? void 0 : images.values[activeImage],
            darkMode: true,
            lists: images
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageSelector.ImageSelector, {
          images: images,
          setActiveImage: setActiveImage,
          modalSelector: true
        })]
      })]
    })
  });
};

exports.ProductImageModal = ProductImageModal;